export const APP_ERROR = 'APP_ERROR';
export const DECLARE_PANEL_SIZE = 'DECLARE_PANEL_SIZE';
export const PAUSE_RELOADING_GRAPHS = 'PAUSE_RELOADING_GRAPHS';
export const RELOAD_GRAPH_IMAGES = 'RELOAD_GRAPH_IMAGES';
export const RESUME_RELOADING_GRAPHS = 'RESUME_RELOADING_GRAPHS';
export const SET_TIME_SLICE = 'SET_TIME_SLICE';
export const START_RELOADING_GRAPHS = 'START_RELOADING_GRAPHS';
export const STOP_RELOADING_GRAPHS = 'STOP_RELOADING_GRAPHS';
export const VIEW_GRAPH_SET = 'VIEW_GRAPH_SET';



/** WEBPACK FOOTER **
 ** ./public/js/lib/constants/action-types.js
 **/